(() => {
  angular
    .module('gm.common.services')
    .factory('GmyScreenSize', GmyScreenSize);

  function GmyScreenSize(
    $document,
    $window
  ) {
    'ngInject';

    return {
      getSize,
      isAtMost,
      isDesktop,
      isMobile,
      isTablet,
    };

    function getSize() {
      return $window.getComputedStyle($document[0].querySelector('body'), '::before')
        .getPropertyValue('content')
        .replace(/['"]+/g, '');
    }

    function getScreenSize() {
      const size = $window.screen.width;
      if (size > 1440) {
        return 'xl';
      } else if (size >= 1200) {
        return 'lg';
      } else if (size >= 992) {
        return 'md';
      } else if (size >= 768) {
        return 'sm';
      } else if (size >= 480) {
        return 'xs';
      }
      return 'xxs';
    }

    function isAtMost(maxSize) {
      const sizes = ['xxs', 'xs', 'sm', 'md', 'lg', 'xl'];
      const currentSize = getSize();
      return sizes.indexOf(currentSize) <= sizes.indexOf(maxSize);
    }

    function isDesktop() {
      const screenSize = getSize();

      switch (screenSize) {
        case 'xxs':
        case 'xs':
        case 'sm':
        case 'md':
          return false;
        case 'lg':
        case 'xl':
        default:
          return true;
      }
    }

    function isMobile() {
      const screenSize = getSize();

      switch (screenSize) {
        case 'xxs':
        case 'xs':
        case 'sm':
          return true;
        case 'md':
        case 'lg':
        case 'xl':
        default:
          return false;
      }
    }

    function isTablet() {
      const screenSize = getScreenSize();
      switch (screenSize) {
        case 'xxs':
        case 'xs':
          return true;
        case 'sm':
        case 'md':
        case 'lg':
        case 'xl':
        default:
          return false;
      }
    }
  }
})();
